import React, { useEffect, useState } from "react";
import { Button, Col, Container, Modal, ModalBody, Nav, Navbar, Offcanvas, OverlayTrigger, Row, Tooltip } from "react-bootstrap";
import { Outlet, useNavigate } from "react-router-dom";
import logo from '../white-logo.png';
import blackLogo from '../black-logo.png';
import defaultAvatar from '../user.png';
import FooterComponent from "../components/shared/FooterComponent";

import { MdMeetingRoom, MdDashboard } from 'react-icons/md';
import { BsFillBuildingsFill, BsQrCodeScan, BsArchive, BsFillFileEarmarkTextFill } from 'react-icons/bs';
import { CgLogOff } from 'react-icons/cg';
import { BiSupport, BiCog, BiTransfer } from 'react-icons/bi';
import { useAuthDispatch, useAuthState } from "../context/AuthContext";
import { AiOutlineCloudDownload } from 'react-icons/ai';
import { FaBell, FaInfoCircle, FaQuestionCircle } from "react-icons/fa";
import { IoIosContact } from "react-icons/io";
import { FaXmark } from "react-icons/fa6";
import EmployeeStage from "../components/anlage/new_anlage/EmployeeStage";

const HwDashLayout = () => {

    const navigate = useNavigate();
    
    const { user, contactPerson, tooltipsTrigger } = useAuthState();
    const dispatch = useAuthDispatch(); 
    const qr = localStorage.getItem('qr') || null;
    
    const [navBg, setNavBg] = useState('bg-energo');
    const [contactPersonModal, setContactPersonModal] = useState(false);
    const [stage, setStage] = useState("contact");


    const changeNavBg = () => {
        window.scrollY >= 10 ? setNavBg('bg-energo-opaque') : setNavBg('bg-energo');
    } 

    useEffect(() => {
        window.addEventListener('scroll', changeNavBg);
        return () => {
            window.removeEventListener('scroll', changeNavBg);
        }
    }, [])

    useEffect(() => {
        var nav = document.getElementById('navbar');
        nav.classList.add('bg-energo');
    }, [contactPerson])


    useEffect(() => {
        if (contactPersonModal) setStage('contact');
    }, [contactPersonModal])



    const logout = (e) => {
        e.preventDefault();
        if (contactPerson) {
            dispatch('CLEAR_CONTACT');
        }
        dispatch("LOGOUT");
        navigate("/logout");
    }

    const removeQr = () => {
        localStorage.removeItem('qr');
        navigate('/hw/dashboard/');
    }

    const removeContactPerson = () => {
        dispatch('CLEAR_CONTACT');
    }

    const toggleTooltips = () => {
        if (tooltipsTrigger === true) dispatch('TOOLTIPS_OFF');
        else dispatch('TOOLTIPS_ON');
    }

    return (
        <>
            <header className="App-header">
                <Navbar id="navbar" variant={navBg === 'bg-energo'? 'dark':'light'} expand="false" fixed="top" className={navBg}>
                    <Container fluid className="upper-nav">
                        <Navbar.Brand href="/hw/dashboard/">
                                <img width="100" src={navBg === 'bg-energo'? logo : blackLogo} alt="brand" className="img-fluid" />
                        </Navbar.Brand>

                        
                        <div style={{display: "flex"}}>
                            <a 
                                href="tooltips/"
                                onClick={e => {e.preventDefault(); toggleTooltips()}} 
                                className={tooltipsTrigger !== undefined && tooltipsTrigger === true ? 
                                        "text-warning glow-effect": 
                                        navBg === 'bg-energo'? 
                                            'text-light':'text-dark'}
                            >
                                <FaInfoCircle size={27} style={{marginTop: 6, marginRight: 10}} />
                            </a>      

                            {contactPerson !== undefined && contactPerson !== null ? 
                                <div className="dropdown">
                                    <button 
                                        style={{marginRight: 30}}
                                        className={`btn btn-link drop-energo dropdown-toggle ${navBg === 'bg-energo'? 'text-white':'text-dark'}`} 
                                        type="button" 
                                        id="dropdownMenuButton1" 
                                        data-bs-toggle="dropdown" 
                                        aria-expanded="false">
                                        <IoIosContact size={30} style={{marginTop: "-3px", marginRight: "5px"}} />
                                        {contactPerson? contactPerson.name : null}
                                    </button>
                                    <ul className="dropdown-menu user-menu shadow-lg animate__animated animate__flipInX" aria-labelledby="dropdownMenuButton1">
                                        <div className="user-menu-header">
                                            <li className="text-center user-menu-header-content">
                                                <small className="text-white"><b>Kontaktperson</b></small><br />
                                                <div className="mt-4">
                                                    <IoIosContact className="text-energo" size={60} />
                                                    <p><b>{contactPerson? contactPerson.name : null}</b></p>
                                                </div>
                                            </li>
                                        </div>
                                        <div className="user-menu-action">
                                            <a onClick={e => {e.preventDefault(); setContactPersonModal(true)}} href="/wechseln" className="dropdown-item text-white">
                                                <BiTransfer className="text-warning" size={25} style={{marginRight: "5px"}} /> Kontaktperson ändern</a>
                                            <a onClick={e => {e.preventDefault(); removeContactPerson()}} href="/abmelden" className="dropdown-item text-white">
                                                <FaXmark className="text-danger" size={25} style={{marginRight: "5px"}} /> Kontaktperson abmelden</a>
                                        </div>
                                    </ul>
                                </div>:
                                <a 
                                    style={{marginRight: 30, marginTop: "auto", marginBottom: "auto"}}
                                    href="kontaktperson/wählen/" 
                                    className={`link-energo ${navBg === 'bg-energo'? 'text-white':'text-dark'}`}
                                    onClick={e => {e.preventDefault(); setContactPersonModal(true)}}
                                >
                                    Kontaktperson auswählen
                                </a>
                            }
                            
                            <Navbar.Toggle aria-controls="offcanvasNavbar-expand-xxl" />
                        </div>

                        <Navbar.Offcanvas aria-labelledby="offcanvasNavbarLabel-expand-xxl" placement="end">
                            <Offcanvas.Header closeButton className="shadow-sm">
                                <Offcanvas.Title className="text-energo">
                                    <Row>
                                        <Col xs="11">
                                            ENERGO Managementportal
                                        </Col>
                                        <Col xs="1" className="text-end">
                                            <a href="/hw/dashboard/profile/" className="link-energo-dark">
                                                <BiCog size={30} />
                                            </a>
                                        </Col>
                                    </Row>
                                </Offcanvas.Title>
                            </Offcanvas.Header>
                            <Offcanvas.Body>
                                <Row>
                                    <Col xs="12" className="text-center">
                                        <OverlayTrigger
                                            placement="left"
                                            overlay={
                                                <Tooltip>
                                                    Sie können ihr Profil-Bild jederzeit in den <BiCog /> Einstellungen ändern. 
                                                    Wenn Ihre E-Mail-Adresse bei gravatar.com hinterlegt ist, verwenden 
                                                    wir anfänglich das dort verfügbare Bild.
                                                </Tooltip>
                                            }
                                        >
                                            <div 
                                                className="avatar-image" 
                                                style={{ 
                                                    backgroundImage: `url(${user?.image_1920 && user.image_1920 !== "False" ? 'data:image/*;base64,' + user.image_1920 : defaultAvatar})`, 
                                                    backgroundSize: 'contain', 
                                                    backgroundPosition: 'center', 
                                                    backgroundRepeat: 'no-repeat' 
                                                }}
                                            >
                                            </div>
                                        </OverlayTrigger>


                                        <br /> <br />
                                        <h4>{user?.name}</h4>
                                        <p className="text-muted">{user?.x_qr_login}</p>
                                        <Button onClick={() => removeQr()} hidden={!qr} className="btn-energo">QR Abmelden</Button>
                                    </Col>
                                </Row>

                                <Row className="mt-5">
                                    <Col xs="12">
                                        <Nav className="justify-content-end flex-grow-1 pe-3">
                                            <Nav.Link href="/hw/dashboard/" hidden={qr}>
                                                <MdDashboard size="30" />
                                                <span className="align-middle nav-links">Dashboard</span>
                                            </Nav.Link>
                                            <Nav.Link href="/hw/dashboard/benachrichtigung/">
                                                <FaBell className="text-primary" size="30" />
                                                <span className="align-middle nav-links">Benachrichtigungen</span>
                                            </Nav.Link>
                                            <Nav.Link href="/hw/dashboard/gebaeude/" hidden={qr}>
                                                <BsFillBuildingsFill className="text-secondary" size="30" />
                                                <span className="align-middle nav-links">Verwaltete Gebäude</span>
                                            </Nav.Link> 
                                            <Nav.Link href="/hw/dashboard/energieliefervertraege/" hidden={qr}>
                                                <BsFillFileEarmarkTextFill className="text-primary" size="30" />
                                                <span className="align-middle nav-links">Aktive Energielieferverträge</span>
                                            </Nav.Link>
                                            <Nav.Link href="/hw/dashboard/download/" hidden={qr}>
                                                <AiOutlineCloudDownload className="text-violet" size="30" />
                                                <span className="align-middle nav-links">Downloadbereich</span>
                                            </Nav.Link>
                                            <Nav.Link href="/hw/dashboard/archive/" hidden={qr}>
                                                <BsArchive className="text-dark" size={30} />
                                                <span className="align-middle nav-links">Archiv</span>
                                            </Nav.Link>
                                            <Nav.Link href="/hw/dashboard/anlagen/top" hidden={!qr}>
                                                <MdMeetingRoom className="text-primary" size="30" />
                                                <span className="align-middle nav-links">Anlagen im Top</span>
                                            </Nav.Link>
                                            <Nav.Link href="/hw/dashboard/anlagen/" hidden={!qr}>
                                                <BsFillBuildingsFill className="text-secondary" size="30" />
                                                <span className="align-middle nav-links">Anlagen im Gebäude</span>
                                            </Nav.Link>
                                            <Nav.Link href="/hw/dashboard/scannen/" disabled style={{opacity: "0.2", background: "white"}}>
                                                <BsQrCodeScan size="30" />
                                                <span className="align-middle nav-links">QR-Code scannen</span>
                                            </Nav.Link>
                                            <Nav.Link href="/hw/dashboard/support/">
                                                <BiSupport className="text-warning" size="30" />
                                                <span className="align-middle nav-links">Support</span>
                                            </Nav.Link>
                                            <Nav.Link href="/hw/dashboard/faq/" disabled style={{opacity: "0.2", background: "white"}}>
                                                <FaQuestionCircle className="text-info" size="30" />
                                                <span className="align-middle nav-links">FAQ</span>
                                            </Nav.Link>
                                            <Nav.Link onClick={e => logout(e)} href="#" className="text-danger">
                                                <CgLogOff className="text-danger" size="30" />
                                                <span className="align-middle nav-links">Abmelden</span>
                                            </Nav.Link>
                                        </Nav>
                                    </Col>
                                </Row>
                            </Offcanvas.Body>
                        </Navbar.Offcanvas>
                    </Container>
                </Navbar>
            </header>
            <main style={{marginTop: "150px"}}>
                <Outlet />
            </main>
            <FooterComponent />
            <Modal size="xl" show={contactPersonModal}>
                <ModalBody>
                    {stage === "contact" ?
                        <EmployeeStage setStage={setStage} setShow={setContactPersonModal} /> :

                    stage === "default" ?
                        <Row>
                            <Col xl="12" className="text-center">
                                <p className="text-energo mb-5">Ausgewählte Kontaktperson</p>
                                <IoIosContact className="text-energo" size={120} />
                                <p className="mt-3"><b>{contactPerson ? contactPerson.name : null}</b></p>
                                <p className="text-muted">{contactPerson ? contactPerson.email : null}</p>
                                <Button 
                                    variant="warning" 
                                    style={{marginRight: 30, marginTop: 50, width: 300}}
                                    onClick={() => setStage("contact")}
                                >
                                    Kontaktperson ändern
                                </Button>
                                <Button 
                                    variant="energo" 
                                    style={{width: 300, marginTop: 50}}
                                    onClick={() => setContactPersonModal(false)}
                                >
                                    Weiter mit ausgewähltem Kontakt
                                </Button>
                            </Col>
                        </Row>
                    :null}
                </ModalBody>
            </Modal>
        </>
    )
}

export default HwDashLayout;